import React from 'react';
import FeatureCards from "../../../../components/FeatureCards/FeatureCards";
import CTA from "../../../../components/Constant/cta/CTA";
import TimelineSection from "../../../../components/TimelineSection/TimelineSection";
import WhySection from "../../../../components/WhySection/WhySection";
import LocationTimeline from "../../../../components/LocationTimeline/LocationTimeline";
import IntroSection from "../../../../components/IntroSection/IntroSection";
import FAQList from "../../../../components/Constant/FAQCard/FAQCard";
import Testimonials from "../../../../components/Constant/Testimonials/Testimonials";
import DetailsSection from "../../../../components/DetailsSection/DetailsSection";
import InfoBlocks from "../../../../components/InfoBlocks/InfoBlocks";
import ServiceCards from "../../../../components/ServiceCards/ServiceCards";
import SEO from "../../../../utils/SEO";

export default function CryptoVASPLicenseMauritius() {

    return (
        <main className='main'>

            <SEO
                title="Mauritius Crypto License | VASP & Token Regulation "
                description="Get a Mauritius VASP license under VAITOS Act (2021). Launch crypto exchanges, wallets, custody, and token projects with FSC regulation support. "
                keywords="Mauritius crypto license, VASP Mauritius, VAITOS Act license, FSC crypto regulation, crypto exchange Mauritius, crypto wallet Mauritius, token issuance Mauritius, digital asset licensing "
                url="/Crypto-vasp-license-mauritius"
            />

            <IntroSection
                title="Crypto & VASP License – Mauritius"
                subtitle="Regulated Exchange, Custody & Token Licensing in a Tier-1 Jurisdiction"
                description="
                <b>Mauritius</b> is a <b>pioneer in digital asset regulation</b>, introducing the <b>VAITOS Act (2021)</b> to regulate <b>Virtual Asset Service Providers (VASPs)</b> and <b>Initial Token Offerings (ITOs)</b>.
                Licensing is supervised by the <b>Financial Services Commission (FSC)</b>, ensuring <b>compliance with FATF standards</b> and providing <b>global credibility</b>.
                "
                badges={
                    [
                        "Exchanges",
                        "Wallets & Custodians",
                        "Token Issuers",
                        "VASP Brokers"
                    ]
                }
                buttonText="Request a Mauritius Crypto Proposal →"
                buttonLink="/quote"
                imageSrc={require("../../../../assets/images/services/crypto-vasp-license-mauritius-hero.png")}
                imageAlt=""
            />

            <section className='section'>
                <div className="container">

                    <WhySection
                        title='Why Choose Mauritius for Crypto?'
                        blocks={
                            [
                                {
                                    items:
                                        [
                                            {
                                                title: "Tier-1 Credibility",
                                                text: "FSC is globally respected."
                                            },
                                            {
                                                title: "Dedicated VASP Law",
                                                text: "Unlike Seychelles or Belize."
                                            },
                                            {
                                                title: "FATF-Compliant",
                                                text: "AML/KYC aligned with global standards."
                                            },
                                            {
                                                title: "Tax Efficiency",
                                                text: "No capital gains tax on digital assets."
                                            },
                                            {
                                                title: "Investor-Friendly",
                                                text: "Institutional investors prefer Mauritius over light offshore centers."
                                            }
                                        ]
                                }
                            ]
                        }
                    />

                    <InfoBlocks
                        title="Categories of VASP Licenses under VAITOS"
                        blocks={
                            [
                                {
                                    title: 'VASP Class A – Advisory & Broker-Dealer',
                                    items:
                                        [
                                            {
                                                text: "Advisory services for crypto assets."
                                            },
                                            {
                                                text: "Brokerage (buy/sell on behalf of clients)."
                                            }
                                        ]
                                },
                                {
                                    title: 'VASP Class B – Custodian & Wallet Provider',
                                    items:
                                        [
                                            {
                                                text: "Safekeeping of crypto assets."
                                            },
                                            {
                                                text: "Institutional custody & digital wallets."
                                            }
                                        ]
                                },
                                {
                                    title: 'VASP Class C – Exchange Services',
                                    items:
                                        [
                                            {
                                                text: "Operation of centralized crypto exchanges (CEXs)."
                                            },
                                            {
                                                text: "Includes spot, derivatives, and token trading."
                                            }
                                        ]
                                },
                                {
                                    title: 'VASP Class D – Token Issuers (ICO/STO/ITO)',
                                    items:
                                        [
                                            {
                                                text: "Projects raising funds via token offerings."
                                            },
                                            {
                                                text: "Requires FSC-approved whitepaper & investor protections."
                                            }
                                        ]
                                },
                                {
                                    title: 'VASP Class E – Other Virtual Asset Services',
                                    items:
                                        [
                                            { text: "Hybrid platforms, DeFi, staking, or blockchain services." }
                                        ]
                                },

                            ]
                        }
                    />

                    <LocationTimeline
                        title="Capital & Requirements"
                        item={
                            [
                                {
                                    title: "Minimum Capital",
                                    text: "USD 250,000–500,000 depending on class."
                                },
                                {
                                    title: "Entity",
                                    text: "Global Business Company (GBC) required."
                                },
                                {
                                    title: "Resident Presence",
                                    text: "Office in Mauritius, resident director, compliance officer."
                                },
                                {
                                    title: "AML/KYC",
                                    text: "Robust framework aligned with FATF Travel Rule."
                                },
                                {
                                    title: "Audit",
                                    text: "Annual financial audits + AML reporting."
                                }
                            ]
                        }
                    />

                    <ServiceCards
                        title='Benefits of a Mauritius VASP License'
                        services={
                            [
                                {
                                    title: "Global Recognition",
                                    text: "Stronger than Seychelles, Belize, or St. Lucia."
                                },
                                {
                                    title: "FATF-Aligned",
                                    text: "No blacklist risk."
                                },
                                {
                                    title: "Banking Access",
                                    text: "Easier than unlicensed/offshore crypto setups."
                                },
                                {
                                    title: "Investor Confidence",
                                    text: "Institutional-grade compliance."
                                },
                                {
                                    title: "Crypto + FinTech Gateway",
                                    text: "Ideal for Africa, India, and Asia."
                                }
                            ]
                        }
                    />

                    <FeatureCards
                        title='Licensing Process'
                        features={
                            [
                                {
                                    title: "Pre-Application Consultation",
                                    text: "Select VASP class (exchange, custodian, broker, token)."
                                },
                                {
                                    title: "Entity Incorporation",
                                    text: "Register a Mauritius GBC."
                                },
                                {
                                    title: "Application Preparation",
                                    text: "AML manuals, whitepaper (if ITO), financials."
                                },
                                {
                                    title: "FSC Review",
                                    text: "Due diligence on shareholders, directors, compliance officers."
                                },
                                {
                                    title: "Approval & Licensing",
                                    text: "Typically 6–9 months."
                                }
                            ]
                        }
                    />

                    <TimelineSection
                        title='Timeline & Costs'
                        items={
                            [
                                {
                                    name: "Timeline",
                                    duration: "6–9 months.",
                                },
                                {
                                    name: "Setup Costs",
                                    description: "from USD 80,000+ (legal, compliance, licensing)."
                                },
                                {
                                    name: "Capital Requirement",
                                    description: "USD 250k–500k depending on activity."
                                },
                                {
                                    name: "Annual Costs",
                                    description: "FSC fees, AML reporting, external audits."
                                },

                            ]
                        }
                    />

                    <DetailsSection
                        title='Why Offshore Advisory?'
                        items={
                            [
                                {
                                    text: "Experts in crypto & VASP licensing under VAITOS."
                                },
                                {
                                    text: "End-to-end support: GBC setup, FSC filing, compliance framework."
                                },
                                {
                                    text: "Partnerships with crypto-friendly banks, PSPs, and custodians."
                                },
                                {
                                    text: "Experience with exchanges, token projects, and custody solutions."
                                },
                                {
                                    text: "Comparative analysis: Mauritius vs Gibraltar vs Malta vs Seychelles."
                                }
                            ]
                        }
                    />

                    <FAQList data={faqData} title='Frequently Asked Questions (FAQ)'/>

                    <Testimonials
                        title="Client Testimonials"
                        testimonials={testimonialsData}
                    />

                    <CTA
                        title="Looking to launch a crypto exchange, custody solution, or token project?"
                        description="Mauritius offers dedicated VASP licensing under FSC, FATF-compliant and globally respected."
                        buttonText="Book a Mauritius Crypto License Consultation →"
                        buttonLink="/quote"
                    />
                </div>
            </section>
        </main>
    );
};

const faqData = [
    {
        question: "What law regulates crypto in Mauritius?",
        content: [
            { type: "answer", text: "The Virtual Asset and Initial Token Offering Services Act (VAITOS, 2021)." },
        ],
    },
    {
        question: "What’s the capital requirement for a Mauritius VASP?",
        content: [
            { type: "answer", text: "USD 250,000–500,000 depending on license type." },
        ],
    },
    {
        question: "Does Mauritius regulate ICOs/STOs?",
        content: [
            { type: "answer", text: "Yes — token issuers must apply under VAITOS with FSC-approved whitepapers." },
        ],
    },
    {
        question: "Why Mauritius over Seychelles?",
        content: [
            { type: "answer", text: "Mauritius has dedicated crypto laws, FATF compliance, and higher reputation." },
        ],
    },
    {
        question: "How long does licensing take?",
        content: [
            { type: "answer", text: "Around 6–9 months." },
        ],
    },
];


const testimonialsData =
    [
        {
            quote: "We licensed our crypto exchange in Mauritius. Offshore Advisory handled VAITOS compliance and FSC approvals.",
            author: "Victor L.",
            role: "Exchange Founder"
        },
        {
            quote: "Mauritius gave our custody project institutional credibility. Offshore Advisory guided us through the FSC licensing.",
            author: "Sofia M.",
            role: "Crypto Custody CEO"
        }
    ]
;
